// Dispatch das confirmações do assistente para os services REAIS de cada módulo.
// Nada de CRUD novo: reaproveita os mesmos services usados pelos formulários.
import { createPerson } from "./personService";
import spiritualLineService from "./spiritualLineService";
import guideService from "./guideService";
import orixaService from "./orixaService";
import { createFunction } from "./functionService";
import { createJourneyStage } from "./journeyStageService";
import attendanceTypeService from "./attendanceTypeService";
import ritualTypeService from "./ritualTypeService";
import { createCard } from "./attendanceCardService";

type Payload = Record<string, any>;

const dispatch: Record<string, (payload: Payload) => Promise<unknown>> = {
	person: (p) => createPerson(p),
	spiritualLine: (p) => spiritualLineService.createSpiritualLine(p as any),
	guide: (p) => guideService.createGuide(p as any),
	orixa: (p) => orixaService.create(p as any),
	function: (p) => createFunction(p as any),
	journeyStage: (p) => createJourneyStage(p),
	attendanceType: (p) => attendanceTypeService.createAttendanceType(p as any),
	ritualType: (p) => ritualTypeService.createRitualType(p as any),
	// Vínculo do atendimento ao tipo de ritual: a rota mora no módulo do ritual.
	attendanceCard: (p) =>
		createCard(p.ritualTypeId, { attendanceTypeId: p.attendanceTypeId }),
};

/** Executa a criação confirmada pelo usuário, usando o service real do módulo. */
export const executePendingAction = (
	resource: string,
	payload: Payload,
): Promise<unknown> => {
	const fn = dispatch[resource];
	if (!fn) {
		return Promise.reject(new Error(`Recurso não suportado: ${resource}`));
	}
	return fn(payload);
};

export const isSupportedResource = (resource: string): boolean =>
	resource in dispatch;
